
export const MessageTypes = {
  TOGGLE_AI_PANEL: "TOGGLE_AI_PANEL",
  REDIRECT: "REDIRECT",
  DISPLAY_MESSAGE: "DISPLAY_MESSAGE",
  SYNC_URL: "SYNC_URL"
};

class MessageBridge {
  /**
   * Send a message to the Shell (Parent Window)
   * @param {string} type - Message Type
   * @param {any} payload - Data
   */
  static sendToShell(type, payload = {}) {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({ type, payload }, "*");
    }
  }

  /**
   * Send a message to the App (Iframe)
   * @param {object} iframeRef - React Ref to the iframe
   * @param {string} type - Message Type
   * @param {any} payload - Data
   */
  static sendToApp(iframeRef, type, payload = {}) {
    if (iframeRef && iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage({ type, payload }, "*");
    }
  }

  /**
   * Listen for messages
   * @param {object} handlers - Object mapping MessageTypes to functions
   * @param {boolean} isShell - True if listening in Shell (validates origin if needed)
   */
  static listen(handlers) {
    const listener = (event) => {
      // In production, check event.origin here for security
      const { type, payload } = event.data || {};
      if (handlers[type]) {
        handlers[type](payload);
      }
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }
}

export default MessageBridge;
